type ChoiceByUrl = { valueName: string } | null;

export function isSameChoice(left: any, right: any, choicesByUrl: ChoiceByUrl) {
  const valueKey = choicesByUrl?.valueName ?? "value";
  return (
    left != null &&
    right != null &&
    typeof left === "object" &&
    typeof right === "object" &&
    left[valueKey] != null &&
    left[valueKey] === right[valueKey]
  );
}
